<template>
<button type="button" @click="openPopup" class="odr-popup-trigger__button">
    <slot></slot>
    <span class="odr-popup-trigger__icon">
        <icon size="s" color="main">arrow_forward</icon>
    </span>
</button>
</template>

<script>
import { popupBus } from '@/utils/popup-bus';
import '@/scss/blocks/popup-trigger.scss';

export default {
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    components: {
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
    },
    methods: {
        openPopup () {
            popupBus.$emit(`open-popup:${this.id}`);
        },
    },
};
</script>
